/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { AlertService } from 'src/app/shared/services/alert.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Injectable } from '@angular/core';
import { Resources } from '../enums';
import { BehaviorSubject, Observable } from 'rxjs';
import { ModalService } from 'src/app/shared/components/modal/modal.service';
import { ErrorsDto } from '../dto/error-dto';
import { Router } from '@angular/router';
import { routesV3 } from 'src/app/layout-v3/shared/const/routes-config';
//import {  TelemetryService } from 'src/app/layout-v3/shared/services/telemetry.service';
import { TelemetryAction } from 'src/app/layout-v3/shared/interfaces/telemetry/telemetry-action';
import { SeverityError } from 'src/app/layout-v3/shared/enum/severity-error';
import { TelemetryEvent } from 'src/app/layout-v3/shared/interfaces/telemetry/telemetry-events';
import { TelemetryService } from 'src/app/layout-v3/shared/services/telemetry.service';
import { TelemetrySources } from 'src/app/layout-v3/shared/interfaces/telemetry/telemetry-sources';
//import { AdminV3Service } from 'src/app/layout-v3/shared/services/admin-v3.service';

@Injectable({
  providedIn: 'root'
})
export class ProblemsInterceptorService {

  public resourceNotFoundSubject: BehaviorSubject<Resources>;
  public resourceNotFound: Observable<Resources>;
  public resourceNotExist !: Resources;
  isV3!: boolean;

  constructor(private authService: AuthService, private alertService: AlertService,
              private matDialog: ModalService, private router: Router, private telemetryService: TelemetryService) {
    this.resourceNotFoundSubject = new BehaviorSubject<Resources>(Resources.Empty);
    this.resourceNotFound = this.resourceNotFoundSubject.asObservable();
  }

  intercept(problem: any): void {
    const loginRoute = this.authService.getRedirectLoginRoute();
    this.resourceNotExist = Resources.Empty;
    if (problem) {
        const typeName = problem.__typename;
   
        switch(typeName) {
          case 'AuthenticationRequiredProblem':
            this.authService.signOut();
            break;
          case 'DeploymentDoesNotExistProblem':
          case 'SchoolDoesNotExistProblem':
            this.resourceNotExist = Resources.School;
            this.matDialog.closeAll();
            this.showNotFoundComponent();
            break;
          case 'ClassDoesNotExistProblem':
          case 'CollectionDoesNotExistProblem':
            this.resourceNotExist = Resources.Classroom;
            this.matDialog.closeAll();
            this.showNotFoundComponent();
            break;
          case 'DistrictDoesNotExistProblem':
            this.resourceNotExist = Resources.District;
            this.matDialog.closeAll();
            this.showNotFoundComponent();
            break;
          case 'TokenDoesNotExistProblem':
            this.router.navigate([loginRoute]);
            break;
          case 'AdminDoesNotExistProblem':
            this.alertService.error('Your account is not registered with us. Please contact', 'Security error',{link: 'mailto:support@itopia.com', linkDescription: 'support'});
            this.authService.signOut();
            break;
          default:
            {
              if(problem.message && problem.__typename !== 'IntegrationNotReadyYetProblem') {
                this.alertService.error(problem.message, 'Validation error');
              }
            }
         
        }
    }
 }
 interceptError(error: ErrorsDto, notify?: boolean, resource?: Resources): void {
    if(error){
        const authRequired = error?.graphQLErrors?.find(x=>x.message.toLowerCase().includes('authentication is required'));
        const auth404 = error?.graphQLErrors?.find(x=>x.message.toLowerCase().includes("you don't have permission")) ||
                        error?.graphQLErrors?.find(x=>x.message.toLowerCase().includes("you are not authorized to access this site"));
       
        if(authRequired) {
          this.authService.signOut();
        } else {
          if(auth404){
            this.resourceNotExist = resource || Resources.District;
            this.matDialog.closeAll();
            this.showNotFoundComponent(error);
          } else {
            if(notify){
              const message = error?.graphQLErrors[0]?.message;
              if(message){
                this.alertService.error(message, 'Validation error');
              }       
            }
          }         
        }
    }
 }

 showNotFoundComponent(error?: any, telemetryData?:TelemetryAction,  telemetrySources?: TelemetrySources ): void {
   if(!location.pathname?.includes('login')){

      const currentDataStr = sessionStorage.getItem('current'); 
      if(telemetryData){
         telemetryData.variables['admin'] = currentDataStr;
      } 

      const telemetryActionData = telemetryData || {
              action: 'NotFoundResource',
              variables: { admin: currentDataStr, resource: this.resourceNotExist },
      } as TelemetryAction;

      this.telemetryService.logError(error,telemetryActionData, SeverityError.ERROR, telemetrySources);
     
       this.authService.setLastDistrict('');
        this.authService.setLastSchool('');
        sessionStorage.removeItem('current');
        sessionStorage.removeItem('districts');
        sessionStorage.setItem('resourceForbidden', 'true');        
        void this.router.navigate([routesV3.forbidden.route]);      
    }
  }
  
}
